import React from "react";
import Typewriter from "typewriter-effect";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import "@fontsource/raleway";
import styled, { keyframes } from "styled-components";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Highlight } from "@mui/icons-material";
import "@fontsource/great-vibes";
import { Shake } from "reshake";

function AnimatedText({ text }) {
  const textArray = text.split("");

  return (
    <Wrapper>
      {textArray.map((char, index) => (
        <span
          key={index}
          style={{ color: "rgb(37, 221, 95)", marginTop: "1rem" }}
        >
          {char}
        </span>
      ))}
    </Wrapper>
  );
}

export default function Professional() {
  return (
    <FLEX>
      <div
        className="text"
        style={{
          fontFamily: "great-vibes",
          fontSize: "3rem",
          color: "rgb(37, 221, 95)",
          backgroundRepeat: "no-repeat",
          width: "100%",
          maxWidth: "500px",
          minWidth: "300px",
          fontWeight: "bold",
          opacity: "0.85",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxSizing: "border-box",
          lineHeight: "1rem",
        }}
      >
        <p style={{ marginBottom: "1rem" }}>
          <span
            style={{
              fontFamily: "Great Vibes",
              color: "rgb(255, 255, 255)",
              marginBottom: "1.5rem",
            }}
          >
            <Shake>Hello, I'm </Shake>
          </span>
          <AnimatedText text="TATHAGAT" />
        </p>
        <p style={{ marginBottom: "1rem" }}>
          {" "}
          <span
            style={{ fontFamily: "Great Vibes", color: "rgb(255, 255, 255)" }}
          >
            {" "}
            <Shake> I'm a</Shake>
          </span>
        </p>

        <Typewriter
          options={{
            strings: [
              "MERN Stack Developer",
              "Creative Web Developer",
              "Full Stack Developer",
            ],
            autoStart: true,
            loop: true,
            deleteSpeed: 80,
          }}
        />
      </div>
      <div
        style={{
          backgroundImage: "url(./circular.gif)",
          color: "rgb(255, 255, 255)",
          width: "100%",
          maxWidth: "300px",
          minWidth: "200px",
          backgroundRepeat: "no-repeat",
          borderRadius: "50%",
          padding: "2rem",
          boxSizing: "border-box",
          backgroundPosition: "center",
          boxShadow:
            "rgba(25, 220, 136, 0.486) 0px 30px 60px -12px inset, rgba(117, 9, 99, 0.3) 0px 18px 36px -18px inset",
          marginRight: "8%",
          zIndex: "11",
        }}
      >
        <img
          src="./Tathagat2.png"
          style={{
            height: "84%",
            borderRadius: "100%",
            width: "100%",
            zIndex: "-1",
            opacity: "0.95",
            backgroundColor: "transparent",
            boxShadow:
              "rgba(237, 103, 226, 0.852) 0px 19px 38px,rgb(4, 145, 143) 0px 10px 12px",
          }}
        ></img>
      </div>
    </FLEX>
  );
}
const FLEX = styled.div`
  background-image: url(./greenDance.gif);
  background-repeat: no-repeat;
  background-size: 100%;
  margin-bottom: 5%;
  width: 100%;
  height: 40%;
  display: flex;
  justify-content: space-between;
  padding-top: 2%;
  border-bottom: "20px solid #04c984";
  padding-bottom: 2%;
  box-shadow: #04ae72 0px 10px 20px, rgb(2, 94, 92) 0px 3px 6px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    justify-content: center;
    align-items: center;
  }

  .text {
    width: 65%;
    display: inline-block;
    margin: auto;
    line-height: 1rem;
    @media (max-width: 768px) {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      line-height: 1rem;
    }
  }

  p {
    margin: 0;
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.5rem;
    color: white;
    text-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }

  .Typewriter {
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.5rem;
    color: rgb(37, 221, 95);
    text-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }

  img {
    height: 100%;
    border-radius: 50%;
    width: 42%;
    opacity: 0.98;
    background-color: transparent;
    box-shadow: rgba(237, 103, 226, 0.852) 0px 19px 38px,
      rgb(4, 145, 143) 0px 10px 12px;
    @media (max-width: 768px) {
      width: 80%;
    }
  }
`;
const animateText = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100px) skewX(10deg) skewY(10deg) rotateZ(30deg);
    filter: blur(10px);
  }
  25% {
    opacity: 1;
    transform: translateY(0px) skewX(0deg) skewY(0deg) rotateZ(0deg);
    filter: blur(0px);
  }
  75% {
    opacity: 1;
    transform: translateY(0px) skewX(0deg) skewY(0deg) rotateZ(0deg);
    filter: blur(1px);
  }
  100% {
    opacity: 0;
    transform: translateY(-100px) skewX(10deg) skewY(10deg) rotateZ(30deg);
    filter: blur(10px);
  }
`;

const Wrapper = styled.span`
  display: inline-block;

  span {
    opacity: 0;
    display: inline-block;
    animation-name: ${animateText};
    animation-duration: 6s;
    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
  }

  span:nth-child(1) {
    animation-delay: 0.1s;
  }
  span:nth-child(2) {
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
  span:nth-child(4) {
    animation-delay: 0.4s;
  }
  span:nth-child(5) {
    animation-delay: 0.5s;
  }
`;
